import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Table } from 'primeng/table';
import { from, Subject } from 'rxjs';
import { distinct, finalize, takeUntil } from 'rxjs/operators';
import { VDealerReport } from 'src/app/models/entities/v-dealer-report';
import { MovementService } from 'src/app/services/movement.service';

@Component({
  selector: 'app-dealer-report',
  templateUrl: './dealer-report.component.html',
  styleUrls: ['./dealer-report.component.css']
})
export class DealerReportComponent implements OnInit {

  bindData: VDealerReport[] = [];
  filteredData: VDealerReport[] = [];

  customers: VDealerReport[] = [];
  dealers: VDealerReport[] = [];
  projects: VDealerReport[] = [];
  contractTypes: VDealerReport[] = [];
  services: VDealerReport[] = [];
  months: VDealerReport[] = [];
  years: VDealerReport[] = [];

  exportDatas: any[] = [];
  year: number = new Date().getFullYear();
  month: number = new Date().getMonth() + 1;
  loading: boolean;

  destroy$ = new Subject<void>();

  @ViewChild('dt', { static: false }) dt: Table;

  constructor(
    private movementService: MovementService
  ) { }

  ngOnInit(): void {
    this.getList();
  }


  getList() {
    this.loading = true;
    this.movementService.getDealerReport().pipe(finalize(() => this.loading = false), takeUntil(this.destroy$)).subscribe(res => {
      this.bindData = res.data;
      from(this.bindData).pipe(distinct(d => d.customerName), takeUntil(this.destroy$)).subscribe(val => this.customers.push(val));
      from(this.bindData).pipe(distinct(d => d.dealerName), takeUntil(this.destroy$)).subscribe(val => this.dealers.push(val));
      from(this.bindData).pipe(distinct(d => d.projectName), takeUntil(this.destroy$)).subscribe(val => this.projects.push(val));
      from(this.bindData).pipe(distinct(d => d.contractTypeName), takeUntil(this.destroy$)).subscribe(val => this.contractTypes.push(val));
      from(this.bindData).pipe(distinct(d => d.serviceName), takeUntil(this.destroy$)).subscribe(val => this.services.push(val));
      from(this.bindData).pipe(distinct(d => d.month), takeUntil(this.destroy$)).subscribe(val => this.months.push(val));
      from(this.bindData).pipe(distinct(d => d.year), takeUntil(this.destroy$)).subscribe(val => this.years.push(val));
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.exportDatas);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "Bayi Raporu");
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + ' ' + formatDate(new Date, 'dd-MM-yyyy', 'en') + EXCEL_EXTENSION);
  }


  filterData($event: Table) {
    this.exportDatas = [];
    this.filteredData = $event.filteredValue;
    for (let index = 0; index < this.filteredData.length; index++) {
      const element = this.filteredData[index];
      this.exportDatas.push(
        {
          "Bayi": element.dealerName,
          "Müşteri": element.customerName,
          "Proje": element.projectName,
          "Hizmet": element.serviceName,
          "Abonelik Tipi": element.contractTypeName,
          "Terminal Adet": element.numberOfTerminals,
          "Birim Fiyat": element.serviceUnitPrice,
          "Toplam Fiyat": element.totalPrice,
          "Para Birimi": element.currencyUnit,
          "Birim Komisyon": element.commissionPrice,
          "Toplam Komisyon": element.totalCommissionPrice,
          "Faturalama Tarihi": element.invoiceDate,
          "Ay": element.month,
          "Yıl": element.year
        }
      )
    }


    this.exportDatas.push(
      {
        "Bayi": "",
        "Müşteri": "",
        "Proje": "",
        "Hizmet": "",
        "Abonelik Tipi": "",
        "Terminal Adet": "",
        "Birim Fiyat": "",
        "Toplam Fiyat": this.calcTotalPrice(),
        "Para Birimi": "",
        "Birim Komisyon": "",
        "Toplam Komisyon": this.calcTotalComPrice(),
        "Faturalama Tarihi": "",
        "Ay": "",
        "Yıl": ""
      }
    )

  }


  calcTerminals() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.numberOfTerminals;
    }
    return total;
  }

  calcServicePrice() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.serviceUnitPrice;
    }
    return total;
  }

  calcTotalPrice() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.totalPrice;
    }
    return total;
  }

  calcComPrice() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.commissionPrice;
    }
    return total;
  }

  calcTotalComPrice() {
    let total = 0;
    for (let data of this.filteredData) {
      total += data.totalCommissionPrice;
    }
    return total;
  }



}
